/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Education_Finished_GradInputs */

const en_onboarding_education_finished_grad = /** @type {(inputs: Onboarding_Education_Finished_GradInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finished grad school`)
};

const es_onboarding_education_finished_grad = /** @type {(inputs: Onboarding_Education_Finished_GradInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé el posgrado`)
};

/**
* | output |
* | --- |
* | "Finished grad school" |
*
* @param {Onboarding_Education_Finished_GradInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_education_finished_grad = /** @type {((inputs?: Onboarding_Education_Finished_GradInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Education_Finished_GradInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_education_finished_grad(inputs)
	return en_onboarding_education_finished_grad(inputs)
});